<template>
  <div class="home">
    <div
      class="scroll-container-vertical"
      :style="{height:scrollVerticalHeight,marginLeft:scrollVerticalMarginLeft}"
    >
      <div class="scroll-container-horizontal">
        <div
          class="scroll-container"
          :style="{transform:`translate3d(${-scrollHeight}px,0px,0px)`}"
        >
          <main ref="scrollContainerHorizontal">
            <section>
              <MainVision />
            </section>

            <section>
              <Video />
            </section>

            <section>
              <LightSpotImages />
            </section>

            <section>
              <LightSpotMix />
            </section>

            <section>
              <GuestsPrevious />
            </section>

            <section>
              <GuestsCurrent />
            </section>

            <section>
              <ForumIntroduceByDay />
            </section>

            <section>
              <ForumIntroduceByPeriod />
            </section>

            <section>
              <ForumMainTable />
            </section>

            <section>
              <ForumMainList />
            </section>

            <section>
              <ParallelForum />
            </section>

            <section>
              <SpecialExhibition />
            </section>

            <section>
              <Awards />
            </section>

            <section>
              <AwardsDemo />
            </section>

            <section>
              <Subscribe />
            </section>

            <section>
              <TicketEntrance />
            </section>

            <section>
              <Partners />
            </section>

            <section>
              <ContactUs />
            </section>

            <section>
              <PreviousReview />
            </section>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainVision from "@/components/pc/MainVision.vue";
import Video from "@/components/pc/Video.vue";
import LightSpotImages from "@/components/pc/LightSpotImages.vue";
import LightSpotMix from "@/components/pc/LightSpotMix.vue";
import GuestsPrevious from "@/components/pc/GuestsPrevious.vue";
import GuestsCurrent from "@/components/pc/GuestsCurrent.vue";
import ForumMainTable from "@/components/pc/ForumMainTable.vue";
import ForumMainList from "@/components/pc/ForumMainList.vue";
import ForumIntroduceByDay from "@/components/pc/ForumIntroduceByDay.vue";
import ForumIntroduceByPeriod from "@/components/pc/ForumIntroduceByPeriod.vue";
import ParallelForum from "@/components/pc/ParallelForum.vue";
import SpecialExhibition from "@/components/pc/SpecialExhibition.vue";
import Awards from "@/components/pc/Awards.vue";
import AwardsDemo from "@/components/pc/AwardsDemo.vue";
import TicketEntrance from "@/components/pc/TicketEntrance.vue";
import Subscribe from "@/components/pc/Subscribe.vue";
import Partners from "@/components/pc/Partners.vue";
import ContactUs from "@/components/pc/ContactUs.vue";
import PreviousReview from "@/components/pc/PreviousReview.vue";

export default {
  name: "HomePC",
  components: {
    MainVision,
    Video,
    LightSpotImages,
    LightSpotMix,
    GuestsPrevious,
    GuestsCurrent,
    ForumMainTable,
    ForumMainList,
    ForumIntroduceByDay,
    ForumIntroduceByPeriod,
    ParallelForum,
    SpecialExhibition,
    Awards,
    AwardsDemo,
    Subscribe,
    TicketEntrance,
    Partners,
    ContactUs,
    PreviousReview
  },
  data() {
    return {
      scrollVerticalHeight: "4000px",
      scrollVerticalMarginLeft: "0px",
      scrollHeight: 0,
      timer: null,
      navVisible: true
    };
  },
  created() {
    window.onload = () => this.setClientSize();
    window.addEventListener("scroll", this.handleScroll, false);
    window.addEventListener("resize", this.setClientSize, false);
  },
  mounted() {
    this.timer = setTimeout(() => {
      // const images = document.querySelectorAll("img");
      // for (let i = 0; i < images.length; i++) {
      //   if (!images[i].complete) {
      //     return;
      //   }
      // }
      this.setClientSize();
    }, 100);
    window.history.scrollRestoration &&
      (window.history.scrollRestoration = "manual");
    // const links = document.querySelectorAll('.navs-container > a');
    // for (let i = 0, { length } = links; i < length; i++) {
    //   links[i].addEventListener('click', function (e) {
    //     const href = this.getAttribute('href');
    //     if (href.startsWith('#')) {
    //       window.scrollTo({
    //         behavior: 'smooth',
    //         top: document.querySelector(href).offsetLeft - document.querySelector('#nav').offsetWidth,
    //       });
    //     } else {
    //       window.open(href, '_blank');
    //     }
    //     e.preventDefault();
    //     return false;
    //   });
    // }
  },
  methods: {
    setClientSize(flag) {
      const CLIENT_WIDTH = document.body.clientWidth;
      const CLIENT_HEIGHT = document.body.clientHeight;
      this.computeScrollVerticalHeight(CLIENT_WIDTH, CLIENT_HEIGHT);
    },
    computeScrollVerticalHeight(CLIENT_WIDTH, CLIENT_HEIGHT) {
      this.scrollVerticalHeight = `${this.$refs.scrollContainerHorizontal
        .offsetWidth -
        CLIENT_WIDTH +
        CLIENT_HEIGHT}px`;
    },
    handleScroll() {
      const scrollHeight =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const scrollInstance = scrollHeight - this.scrollHeight;
      this.scrollHeight = scrollHeight;
      if (this.scrollHeight <= 0) {
        this.navVisible = true;
        // this.scrollVerticalMarginLeft = `${document.querySelector('#nav').offsetWidth}px`;
        return;
      }
      if (scrollInstance < 0) {
        this.navVisible = true;
        // this.scrollVerticalMarginLeft = `${document.querySelector('#nav').offsetWidth}px`;
      } else {
        this.navVisible = false;
        this.scrollVerticalMarginLeft = "0px";
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.setClientSize);
    clearTimeout(this.timer);
  }
};
</script>

<style scoped lang="less">
.home {
  position: relative;
  height: 100vh;
}

.ticket {
  transition: transform 0.3s;

  &:hover {
    transform: scale(1.5);
  }
}

.scroll-container-vertical {
  overflow-scrolling: touch;
}

.scroll-container-horizontal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.scroll-container {
  height: 100vh;
  align-self: flex-end;
}

main {
  display: flex;
  position: relative;
}

section {
  height: 100vh;
}
</style>
